import { createSlice } from "@reduxjs/toolkit"
import { BikeFleetStateProps } from "../types/bikeFleetType"
import { CheckOutStateEnum } from "store/type"
import { handleBikeFleetBuilder, handleUpdateBikeStatusBuilder } from "./bikeFleetBuilder"
import * as reducerActions from "./bikeFleetReducerActions" // Importer les fonctions reducers

const initialState: BikeFleetStateProps = {
	selectBikeFleetAll: false,
	currentBikeFleetStatusSelected: false,
	bikeFleet: [],
	checkOutState: {
		updateBike: CheckOutStateEnum.INIT,
		bikeFleet: CheckOutStateEnum.INIT,
	},
	searchBikeFLeet: "",
	filteredBikeFleet: [],
	error: {
		updateBike: false,
		bikeFleet: false,
	},
	updateBike: {
		success: [],
		error: [],
	},
}

export const bikeFleetSlice = createSlice({
	name: "bikeFleet",
	initialState: initialState,
	reducers: {
		// Action to set the search parameter for the bike fleet.
		setSearchBikeFleet: reducerActions.setSearchBikeFleet,
		// Action to get the filtered bike fleet based on the current search and status.
		getFilteredBikeFleet: reducerActions.getFilteredBikeFleet,
		// Action to toggle the selected status of a bike by its FNUCI code.
		setToggleCheckedByCodeFnucy: reducerActions.setToggleCheckedByCodeFnucy,
		// Action to toggle the 'checked' status of all bikes.
		setToggleCheckedAll: reducerActions.setToggleCheckedAll,
		resetUpdatedBikeStatus: reducerActions.resetUpdatedBikeStatus,
	},
	extraReducers(builder) {
		// Inject Builder
		handleBikeFleetBuilder(builder)
		handleUpdateBikeStatusBuilder(builder)
	},
})

// Export Actions
export const {
	resetUpdatedBikeStatus,
	getFilteredBikeFleet,
	setSearchBikeFleet,
	setToggleCheckedAll,
	setToggleCheckedByCodeFnucy,
} = bikeFleetSlice.actions
